import React from 'react'
import { Link } from 'react-router-dom'
import { FiFacebook, FiLinkedin, FiTwitter } from 'react-icons/fi'

const Footer = () => {
    return (
        <footer className="bg-gray-900 dark:bg-gray-950 text-white pt-20 pb-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
                    {/* Brand Column */}
                    <div className="col-span-2 md:col-span-1">
                        <div className="flex items-center space-x-3 mb-6">
                            <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex items-center justify-center">
                                <span className="text-white font-bold text-lg">S</span>
                            </div>
                            <span className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">STACKLY</span>
                        </div>
                        <p className="text-gray-400 mb-6 text-sm leading-relaxed">
                            The most powerful URL shortener with advanced analytics and digital tools for modern teams.
                        </p>
                        <div className="flex space-x-3">
                            <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-gray-700 rounded-lg flex items-center justify-center transition-all duration-300 group">
                                <FiFacebook className="text-blue-400 group-hover:text-blue-300 text-lg" />
                            </a>
                            <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-gray-700 rounded-lg flex items-center justify-center transition-all duration-300 group">
                                <FiTwitter className="text-sky-400 group-hover:text-sky-300 text-lg" />
                            </a>
                            <a href="https://www.linkedin.com/company/forepine/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-gray-800 hover:bg-gray-700 rounded-lg flex items-center justify-center transition-all duration-300 group">
                                <FiLinkedin className="text-blue-400 group-hover:text-blue-300 text-lg" />
                            </a>
                        </div>
                    </div>

                    {/* Product Links */}
                    <div>
                        <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-300 mb-5">Product</h3>
                        <ul className="space-y-3">
                            <li><a href="#" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">URL Shortener</a></li>
                            <li><a href="#" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">Analytics</a></li>
                            <li><a href="#" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">QR Codes</a></li>
                            <li><a href="#" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">Team Tools</a></li>
                        </ul>
                    </div>

                    {/* Company Links */}
                    <div>
                        <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-300 mb-5">Company</h3>
                        <ul className="space-y-3">
                            <li><a href="https://docs.stackly.in/about-us" target='_blank' className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">About</a></li>
                            <li><a href="#" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">Blog</a></li>
                            <li><a href="#" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">Careers</a></li>
                            <li><a href="#" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">Contact</a></li>
                        </ul>
                    </div>

                    {/* Support Links */}
                    <div>
                        <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-300 mb-5">Support</h3>
                        <ul className="space-y-3">
                            <li><a href="https://docs.stackly.in" target='_blank' className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">Help Center</a></li>
                            <li><a href="#" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">API Docs</a></li>
                            <li><a href="https://stackly.in/api/health-check" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">Status</a></li>
                            <li><a href="#" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">Security</a></li>
                        </ul>
                    </div>

                    {/* Complaint Links */}
                    <div>
                        <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-300 mb-5">Complaint</h3>
                        <ul className="space-y-3">
                            <li><Link to="/complain" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">Report an Issue</Link></li>
                            <li><a href="#" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">Feedback</a></li>
                            <li><a href="#" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">Support</a></li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Section */}
                <div className="border-t border-gray-800 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center">
                    <p className="text-gray-500 text-xs">
                        © {new Date().getFullYear()} Forepine. All rights reserved.
                    </p>
                    <div className="flex space-x-6 mt-4 md:mt-0">
                        <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors duration-300">Privacy Policy</a>
                        <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors duration-300">Terms of Service</a>
                        <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors duration-300">Cookie Policy</a>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer